import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { asyncRoutes } from './routes'
import { basicRoutes } from './routes/basic'

const routes: RouteRecordRaw[] = [...asyncRoutes, ...basicRoutes]

export { routes }

export default createRouter({
  history: createWebHistory(),
  routes
})
